import React from "react";
import { Wrench, Flame, Droplets, Search, RefreshCw, Siren, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Home Inspection",
  description: "Comprehensive visual inspection for buyers, sellers, and homeowners, covering the home's major systems and visible components.",
  icon: Search,
  badge: null,
  link: "#"
}, {
  title: "Wind Mitigation",
  description: "Specialized inspection of roof-to-wall attachments and openings to help homeowners qualify for significant insurance premium discounts.",
  icon: Siren,
  badge: "Insurance",
  link: "#"
}, {
  title: "4-Point Inspection",
  description: "Focused evaluation of the roof, electrical, plumbing, and HVAC systems, commonly requested for older homes and insurance underwriting in Florida.",
  icon: Wrench,
  badge: "Required",
  link: "#"
}, {
  title: "Condo Inspection",
  description: "Interior-focused inspection for condo buyers and owners, including visible components, fixtures, appliances, and accessible systems within the unit.",
  icon: RefreshCw,
  badge: null,
  link: "#"
}, {
  title: "Mold Testing",
  description: "Professional air and surface sampling to detect hidden moisture issues and fungal growth, critical in Florida's high-humidity climate.",
  icon: Droplets,
  badge: null,
  link: "#"
}, {
  title: "Pre-Listing Inspection",
  description: "Proactive assessment for sellers to identify and address potential deal-breakers before the property hits the competitive Florida market.",
  icon: Flame,
  badge: null,
  link: "#"
}];
export default function ProfessionalPlumbingSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="7240" id="our-inspection-services" className="bg-background py-24 relative overflow-hidden" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-3xl md:text-5xl font-extrabold text-secondary mb-4 uppercase tracking-tighter">
            Inspection Services in South Florida
          </h2>
          <p className="text-lg text-muted-foreground">
            Trusted Inspections provides buyer, seller, condo, insurance, and mold inspection services across South Florida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => <div key={index} data-index={index} className={`transition-all duration-700 delay-[${index * 100}ms] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <Card className="group h-full border border-border bg-card hover:border-primary hover:-translate-y-2 transition-all duration-300 shadow-lg hover:shadow-xl relative overflow-hidden">
                <CardHeader className="pb-4">
                  <div className="flex justify-between items-start">
                    <div className="w-full aspect-video rounded-lg bg-muted flex items-center justify-center mb-4 overflow-hidden group-hover:bg-accent transition-colors duration-300">
                      <service.icon className="size-12 md:size-14 text-secondary group-hover:text-primary group-hover:scale-110 transition-all duration-500" strokeWidth={1.2} />
                    </div>
                  </div>
                  <div className="flex justify-between items-center mb-2">
                    <CardTitle className="text-[22px] font-bold text-secondary group-hover:text-primary transition-colors">
                      {service.title}
                    </CardTitle>
                    {service.badge && <Badge variant="secondary" className="bg-primary text-primary-foreground font-semibold px-2 py-0.5 rounded-sm text-[10px] uppercase">
                        {service.badge}
                      </Badge>}
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-2 mt-auto">
                  <Link to={service.link} className="group/link inline-flex items-center text-sm font-bold uppercase tracking-wider text-primary hover:text-primary/80 transition-colors">
                    Learn More
                    <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}